module.exports = __webpack_public_path__ + "img/18.6e96b0c8.svg";